import { useCallback } from 'react'
import { useActivitiesContext } from '../../../../context'
import { closeContentActionCreator } from '../../../../state'
import { useIsUnmounted } from '@sales-center/components'
import { updateActivityStatusEffect } from '../../../../effects'
import { useFormikContext } from 'formik'
import { ActivityStatus } from '../../../../constants'
import { ENTITY_TYPES } from '@sales-center/common'
import { useRefreshActivityHistory } from '@user/features/Activity/hooks'
import { useAppDispatch } from '@user/store/hooks'
import { useSelector } from 'react-redux'
import { fetchOverdueActivitiesCount } from '@user/features/Activity/store'
import { selectCurrentUser } from '@user/store/authorization'
import { UseData } from './useData'

type Props = Pick<UseData, 'setDisableSave'> & {
  entityId: number
  entityType: ENTITY_TYPES
}

export function useHandlers(props: Props) {
  const { entityId, entityType, setDisableSave } = props
  const [{ current }, dispatch] = useActivitiesContext()
  const isUnmounted = useIsUnmounted()
  const { values } = useFormikContext<{ status: ActivityStatus }>()
  const { refreshHistory } = useRefreshActivityHistory(entityId, entityType)
  const appDispatch = useAppDispatch()
  const { userId } = useSelector(selectCurrentUser)
  const handleCancelClick = useCallback(() => {
    dispatch(closeContentActionCreator())
  }, [dispatch])

  const handleSaveClick = useCallback(async () => {
    setDisableSave(true)

    const action = await updateActivityStatusEffect({
      id: current || -1,
      status: values.status,
    })
    await appDispatch(fetchOverdueActivitiesCount(userId))
    if (isUnmounted()) return
    refreshHistory()

    dispatch(action)
  }, [
    setDisableSave,
    current,
    values.status,
    appDispatch,
    userId,
    isUnmounted,
    refreshHistory,
    dispatch,
  ])

  return {
    handleCancelClick,
    handleSaveClick,
  }
}
